import { render, staticRenderFns } from "./GiftCertificateIndex.vue?vue&type=template&id=8f0a9544"
import script from "./GiftCertificateIndex.vue?vue&type=script&lang=ts"
export * from "./GiftCertificateIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports